import { useContext } from 'react'

import ClientPortalThemeContext from 'contexts/ClientPortalThemeContext'

const useClientPortalTheme = () => {
  const context = useContext(ClientPortalThemeContext)

  if (context === undefined) {
    throw new Error(
      'useClientPortalTheme must be used within a ClientPortalThemeContext.Provider',
    )
  }

  return {
    clientPortalTheme: context.clientPortalTheme,
    isLoading: context.isLoading,
  }
}

export default useClientPortalTheme
